import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddEditVendor, VendorList, VendorOverview } from "../../components/vendor";
import { CREATE_VENDOR, VIEW_VENDOR_ANALYTICS } from "../../constants";
import { useHasPermission } from "../../utils";

export const Vendors = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hasAddVendor = useHasPermission(CREATE_VENDOR);
  const hasViewAnalytics = useHasPermission(VIEW_VENDOR_ANALYTICS);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  // Check if the user has permission to create vendor
  const buttons = [
    hasAddVendor && {
      buttonText: "Add Vendor",
      buttonIcon: Add,
      onClick: handleOpenModal,
    },
  ];

  return (
    <>
      <PageLayout>
        {/* header section */}
        <PageHeader
          // title
          title="Vendors"
          subtitle={`${totalCount} Vendors`}
          // button
          buttons={buttons}
        />

        {hasViewAnalytics ? (
          <>
            <Box sx={{ position: "relative", height: 40 }}>
              <VendorOverview />
            </Box>
            <VendorList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
          </>
        ) : (
          <Box sx={{ mt: -9, position: "relative", zIndex: 2 }}>
            <VendorList totalCount={totalCount} setTotalCount={setTotalCount} reloadData={reload} />
          </Box>
        )}
      </PageLayout>

      {/* add vendor modal */}
      <AddEditVendor open={openModal} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
